const AntSynSymbol = ({ type }) => {
  if (type === "ant") {
    return (
      <div
        style={{
          marginTop: "3px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "20px", // 크기 조정 가능
          height: "20px",
          borderRadius: "100%",
          backgroundColor: "#D9D9D9", // 회색 배경
          color: "#737373",
          fontSize: "14px",
          fontWeight: "bold",
          flexShrink: 0,
        }}
      >
        ⇄
      </div>
    );
  } else if (type === "syn") {
    return (
      <div
        style={{
          marginTop: "3px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "20px", // 크기 조정 가능
          height: "20px",
          borderRadius: "100%",
          backgroundColor: "#D9D9D9", // 회색 배경
          color: "#737373",
          fontSize: "20px",
          fontWeight: "bold",
          flexShrink: 0,
        }}
      >
        =
      </div>
    );
  } else return <div></div>;
};

export default AntSynSymbol;
